import React, {CSSProperties} from 'react';

export enum ECTALinkTarget {
	'Same Tab' = '_self',
	'New Tab' = '_blank',
}

export type TLinkAttributes = {
	title: string;
	to?: string;
	href?: string;
	rel?: string;
	target?: '_blank' | '_self' | '_parent' | '_top';
	className?: string;
	onClick?: () => void;
};

/**
 * CMS "Target Product" field value (JSON Object, single selection)
 */
interface ITargetProduct {
	type?: 'product';
	items?: {
		id: string;
		name?: string;
		slugUrl?: string;
	}[];
}

export interface ICTAProps {
	title?: string;
	renderTitle?: boolean;
	targetUrl?: string;
	longTargetUrl?: string;
	targetPage?: {
		props: {
			slug: string;
		};
	};
	targetCategory?: string;
	targetProduct?: ITargetProduct;
	targetElement?: string;
	media?: React.ReactElement;
	image?: React.ReactElement;
	icon?: string;
	backgroundColor?: string;
	color?: string;
	sys?: {
		id: string;
	};
	linkTarget?: ECTALinkTarget;
	queryParameters: Record<string, string>;
	variant: string;
	showOnDevice?: 'mobile' | 'desktop';
	style?: CSSProperties;
	classNames?: string;
}
